import React from 'react'
import './LegalServicesclinic.scss'
import SectionTitle2 from '../../components/SectionTitle/SectionTitle2'
import img from '../../assets/ragging/leagalservices.jpeg'

const CommitteeRow = ({ title, role }) => (
  <div className="lsc__row">
    <div className="lsc__cell lsc__cell--title">{title}</div>
    <div className="lsc__cell">{role}</div>
  </div>
);


export default function LegalServicesclinic() {
  return (
     <>
      <SectionTitle2 title="Legal Services Clinic" />
      <section className="lsc__grid">
        <article className="lsc__card lsc__card--img">
          {/* <h2 className="card__title">Objective</h2> */}
          <img src={img} alt="" />
        </article>
        <div className="lsc__card lsc__card--1">
          <h2 className="card__title">Introduction</h2>
          <p>
            Bengaluru Law College stands at the forefront of legal education by strongly advocating the principle of “Justice for All.” Through its Legal Services Clinic and Legal Services Committee, the institution integrates academic learning with meaningful community engagement. The college’s initiatives aim to empower underprivileged communities, foster legal awareness, and train law students to become socially responsible legal professionals committed to advancing social justice.
          </p>
          <p>Grounded in the vision of the Legal Services Authorities Act, 1987, and guided by Article 39A of the Indian Constitution, the College uses legal education as a tool for transformation, bridging the gap between law and society.</p>
        </div>
        <div className="lsc__card lsc__card--2">
          <h2 className="card__title">Ideology of the Legal Services Clinic</h2>
          <p>
            The Legal Services Clinic operates with the belief that justice must be accessible to every individual, irrespective of socio-economic background. Its core goals include:</p>
            <ul>
                <li>Providing free legal aid and advice</li>
            <li>Enhancing legal literacy among marginalized communities</li>
            <li>Encouraging pro bono culture among students</li>
            <li>Training law students to become ethically responsible professionals</li>
            <li>Promoting social justice and human rights</li>
            </ul>
            <p>The Clinic nurtures a learning environment where students engage directly with real legal challenges, understand grassroots issues, and contribute towards building a more equitable society.    </p>
        </div>
        <div className="lsc__card lsc__card--3">
          <h2 className="card__title">Objectives and Vision of the Legal Services Committee</h2>
          <p>
            The Legal Services Committee aims to educate, empower, and enable citizens—especially the underserved—to exercise their legal rights. Its vision includes:
          </p>
          <ul>
            <li>Building a legally aware and empowered community</li>
          <li>Making legal services approachable and accessible</li>
          <li>Encouraging preventive legal education</li>
          <li>Transforming students into social justice–oriented professionals</li>
          <li>Strengthening the bridge between legal literacy and justice delivery</li>
          </ul>
        </div>
        <div className="lsc__card lsc__card--4">
          <h2 className="card__title">Committee Structure</h2>
          <strong>
            Convenor
          </strong>
          <ul>
            <li><strong>Convenor : </strong>Dr. Devika S. Ajila, Principal, Bengaluru Law College</li>
            <li><strong>Co ordinator :</strong> Smt. Harika S. S, Assistant Professor</li>
          </ul>
          <strong>Student Leadership</strong>
          <ul>
            <li><strong>Student Convenor:</strong> Dilip J</li>
            <li><strong>Student Co-Convenor:</strong>Sneha M</li>
            <li><strong>Student Secretary:</strong>Srishaila G S</li>
            <li><strong>Student Joint Secretary:</strong>Malthesh</li>
            <li><strong>Executive Member:</strong>Kiran R</li>
          </ul>
        </div>
        <div className="lsc__card lsc__card--5">
          <h2 className="card__title">Sub-Committees of the Legal Services Clinic</h2>
          <strong>1. Awareness & Outreach Cell</strong>
          <ul>
            <li>Conducts legal awareness drives, workshops, seminars</li>
            <li>Collaborates with NGOs, police stations, schools, and local bodies</li>
            <li>Organizes campaigns on key social and legal issues</li>
          </ul>
          <strong>2. Organizes campaigns on key social and legal issues</strong>
          <ul>
            <li>Provides free legal advice under expert supervision</li>
            <li>Conducts legal aid camps in rural and urban areas</li>
            <li>Helps citizens understand rights, documentation, and legal remedies</li>
          </ul>
            <strong>3. Reselsch & Documentation Cell</strong>
            <ul>
                <li>Prepares reselsch reports, case studies, and publications</li>
                <li>Documents all outreach activities</li>
                <li>Maintains lschives for institutional records</li>
            </ul>
            <strong>4. Training & Development Cell</strong>
            <ul>
                <li>Conducts training sessions, certificate programs, skill-building workshops</li>
                <li>Provides internships and practical exposure</li>
                <li>Enhances counseling, advocacy, and drafting skills</li>
            </ul>
        </div>
        <div className="lsc__card lsc__card--6">
          <h2 className="card__title">Major Collaborations</h2>
          <strong>District Legal Services Authority (DLSA)</strong>
          <p>Free legal aid, legal literacy camps, paralegal volunteer training</p>
          <strong>Aasare Foundation</strong>
          <p>Work with old-age homes and orphanages; counseling and rights-awareness.</p>
          <strong>Basaveshwara Nagar Police Station & Cyber Crime Division</strong>
          <p>Sessions on women’s safety, citizens’ rights, cyber law, and digital safety.</p>
          <strong>Karnataka Judicial Academy</strong>
          <p>Lectures, seminars, and training on judicial ethics, constitutional values, and technological advancements in justice.</p>
          <strong>TV 12 Media</strong>
          <p>Media-based legal awareness programs and public education broadcasts.</p>
          <strong>VLS Schools</strong>
          <p>Awareness programs for school students on rights, duties, and safety.</p>
          <strong>Adopted Villages</strong>
          <ul>
            <li>Soladevanahalli</li>
            <li>Sondekoppa</li>
            <li>Avalakuppe</li>
            <p>Regular legal aid camps, awareness sessions, and dispute resolution support.</p>
          </ul>
        </div>
        <div className="lsc__card lsc__card--7">
          <h2 className="card__title">Role of Bengaluru Law College in Promoting Social Justice</h2>
          <p>The college contributes to social justice through multidimensional initiatives such as:</p>
        </div>
        <div className="lsc__card lsc__card--8">
          <h2 className="card__title">Support and Counseling</h2>
          <p>
            The college ensures emotional and psychological support to victims through counseling sessions and peer guidance. The institution stands by every student and staff member to ensure justice, fairness, and dignity.
          </p>
        </div>
        
        <div className="lsc__card lsc__card--10">
            <h2 className="card__title">Key Activities of the Legal Services Committee</h2>
            <strong>A. Legal Awareness Programs</strong>
            <p>Programs conducted include:</p>
            <ul>
                <li><strong>Road Safety Awareness</strong> with Vijayanagar Police</li>
                <li><strong>No Tobacco Awareness</strong> Rally featuring Dr. Ravi Prakash</li>
                <li><strong>World Anti-Child Labour Day </strong>at Rajiv Gandhi School</li>
                <li><strong>Vigilance Awareness</strong> Week address by Ex-Lokayukta Officer Shri Prasanna V Raju</li>
                <li><strong>Girl Child and Senior Citizen Awareness Programs</strong> at VLS International School</li>
                <li>Human Chain Rally for <strong>International Day of the Girl Child</strong> (with BOSCO)</li>
                <p>These programs promote responsible citizenship, ethical behavior, and social welfare.</p>
            </ul>

            <strong>B. Legal Aid and Counseling</strong>
            <ul>
                <li>Free legal counseling to marginalized communities</li>
                <li>Guidance on government schemes, pensions, domestic issues, and cybercrime</li>
                <li>Alumni-led professional mentorship and representation</li>
            </ul>

            <strong>C. Legal Literacy Camps</strong>
            <p>Held in adopted villages and urban localities, covering:</p>
            <ul>
                <li>Women & child protection</li>
            <li>Consumer rights</li>
            <li>Cybercrime prevention</li>
            <li>Government welfare schemes </li>
            <li>Cleanliness and environmental protection</li>
            </ul>

            <strong>D. Lok Adalats & Mediation Support</strong>
            <p>Students participate in Lok Adalats and mediation centers to understand:</p>
            <ul>
                <li>ADR mechanisms</li>
            <li>Settlement procedures</li>
            <li>Speedy justice delivery</li>
            </ul>

            <strong>E. Community Engagement</strong>
            <p>Partnerships with NGOs, DLSA, Police, Cyber Cell, and welfare organizations ensure: </p>
            <ul>
                <li>Para-legal volunteer training</li>
                <li>Grassroots legal empowerment</li>
                <li>Rights-based community education</li>
            </ul>
        </div>
        <div className="lsc__card lsc__card--11">
            <h2 className="card__title"> Workshops, Training & Judicial Exposure</h2>
            <p>Students attend:</p>
            <ul>
                <li>Symposiums on legal service authorities</li>
                <li>Judicial academy lectures</li>
                <li>Judge induction programs</li>
                <li>Constitution and ethics lectures</li>
                <li>Training in evidence, technology, and judicial processes</li>
            </ul>
            <p>Bengaluru Law College was recognized among the Top 3 Legal Service Clinics in Bengaluru at the prestigious Kanoonu Santhe organized by Ramaiah College of Law.</p>
        </div>
        <div className="lsc__card lsc__card--12">
            <h2 className="card__title">Pro Bono Initiatives & Field Visits</h2>
            <strong>Pro Bono Work</strong>
            <ul>
                <li>Free legal services to vulnerable communities</li>
                <li>Adoption of three rural villages</li>
                <li>Alumni serving as village legal representatives</li>
                <li>Free education for underprivileged children</li>
            </ul>
            <strong>Field Visits</strong>
            <p>Students gain firsthand exposure through visits to:</p>
            <ul>
                <li>Courts & Lok Adalats</li>
                <li>Police stations</li>
                <li>Child Welfare Committees</li>
                <li>NIMHANS mental health support systems</li>
                <li>Central Jail, Parappana Agrahara</li>
                <li>Juvenile Justice Board</li>
            </ul>
            <p>These visits cultivate legal skills, empathy, and understanding of real-world justice systems.</p>
        </div>
        <div className="lsc__card lsc__card--13">
            <h2 className="card__title">Internships & Practical Learning</h2>
            <p>Students intern with:</p>
            <ul>
                <li>District Legal Service Authorities</li>
                <li>Police units</li>
                <li>Legal aid committees</li>
                <li>Child and Women Welfare Departments</li>
            </ul>
            <p>They learn:</p>
            <ul>
                <li>Courtroom procedures</li>
                <li>Client counseling</li>
                <li>Drafting legal documents</li>
                <li>Evidence and argumentation</li>
                <li>Social justice mechanisms</li>
            </ul>
            <p>Outcomes include improved professionalism, ethical awareness, and access-to-justice understanding.</p>
        </div>
        <article className="lsc__card lsc__card--committee mt-1">
          <h3 className="card__title">For Legal  service</h3>
          <div className="committee ">
            <CommitteeRow title=" legal services coordinator" role="Smt.Harika s s" />
            <CommitteeRow title="Contact" role="+91 8147142990" />
            
          </div>
          {/* <p className="lsc__small">(Note: Names & contacts should be displayed on the notice board and website.)</p> */}
        </article>
        <div className="lsc__card lsc__card--9">
          <h2 className="card__title">Declaration</h2>
          <p>
            Bengaluru Law College believes that education thrives in an environment of mutual trust and respect. By enforcing a strict Anti-Sexual Harassment Policy and fostering awareness, the institution aims to build a culture of equality, accountability, and integrity.
          </p>
          <ul>
            <li>Conducting legal awareness programs on women’s rights, child protection, domestic violence, consumer laws, environmental laws, cyber safety</li>
            <li>Organizing pro bono counseling and documentation support</li>
            <li>Encouraging student participation in outreach programs and rural camps</li>
            <li>Promoting inclusivity on campus through scholarships and grievance redressal mechanisms</li>
            <li>Fostering interdisciplinary learning through seminars and reselsch initiatives</li>
          </ul>
          <p>Through these efforts, the college nurtures committed professionals who understand the importance of legal service in nation-building.</p>
        </div>
      </section>
    </>
  )
}

